import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { u as useForwardPropsEmits } from "../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { _ as _sfc_main$1 } from "../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tooltip/TooltipRoot.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tooltip",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    delayDuration: {},
    disableHoverableContent: { type: Boolean },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props, { emit: __emit }) {
    const forwarded = useForwardPropsEmits(__props, __emit);
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({ "data-slot": "tooltip" }, unref(forwarded)), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  _sfc_main as default
};
